module.exports = __webpack_public_path__ + "static/img/far1_active.fcd93a9e.png";